export interface LocationStatus {
	id: number;
	statusId: number;
	statusName: string;
	notes: string;
	action: string;
	createdOn: Date;
	createdBy: string;
	startDate: Date | undefined;
	endDate: Date | undefined;
	canEdit: boolean;
	canEditStatus: boolean;
}

export enum LocationStatusEnum {
	Pending = 0,
	Active = 1,
	Inactive = 2,
	Suspended = 3,
	PendingCorporateApproval = 4,
	PendingLocalApproval = 5,
	RoEDenied = 6,
	RoERevoked = 7, // not an active status but might be old code
}
